<template>
  <date-picker v-model="inputVal"
               @input="input" value-type="timestamp"
               :clearable="false"
               :type="unit"
  >
    <template v-slot:input>
      <button class="btn btn-outline-dark dropdown-toggle"
              name="date"
              type="button">
        <i class="icon12-calendar-primary icon-left"></i>
        <span v-if="label">{{ label }}</span>
        <span v-if="label&&selected">: </span>
        <span>{{ selected }}</span>
      </button>
    </template>
    <template v-slot:icon-calendar>&nbsp;</template>
  </date-picker>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';

export default {
  components: {DatePicker},
  props: {
    model: Object,
    attribute: {
      type: String,
      default: 'from'
    },
    unit: {
      type: String,
      default: 'date'
    },
    label: String,
    defaultShortcut: Number,
  },
  data() {
    return {
      inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
    };
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        if (val[this.attribute] != null) {
          this.inputVal = this.model[this.attribute];
        }
      }, deep: true
    },
  },
  computed: {
    selected() {
      if (!this.inputVal) {
        return null;
      }
      if (this.unit === 'date') {
        return moment(this.inputVal, 'x').startOf(this.unit).format('LL');
      }
      if (this.unit === 'week') {
        return moment(this.inputVal, 'x').startOf(this.unit).format('LL') + ' -> ' + moment(this.inputVal, 'x').endOf(this.unit).format('LL');
      }
      if (this.unit === 'month') {
        return moment(this.inputVal, 'x').startOf(this.unit).format('MM/YYYY');
      }
      return null;
    }
  },
  methods: {
    input() {
      if (this.inputVal) {
        this.model[this.attribute] = parseInt(moment(this.inputVal, 'x').startOf(this.unit).format('x'));
      } else {
        this.model[this.attribute] = null;
      }
      this.$emit('change');
    },
  },
}
</script>

<style>
.mx-datepicker {
  width: auto;
}
</style>